module.exports = __webpack_public_path__ + "static/media/comment-lines.8c8b94a3.svg";